export enum SectionColumnConfigFontStyle {
  Normal = 'Normal',
  Bold = 'Bold',
  Italics = 'Italics',
  Strikethrough = 'Strikethrough',
  Underline = 'Underline'
}
